import { render, staticRenderFns } from "./ColorCodeLegend.vue?vue&type=template&id=e21ed642&scoped=true&"
import script from "./ColorCodeLegend.vue?vue&type=script&lang=js&"
export * from "./ColorCodeLegend.vue?vue&type=script&lang=js&"
import style0 from "./ColorCodeLegend.vue?vue&type=style&index=0&id=e21ed642&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e21ed642",
  null
  
)

export default component.exports